<template>
  <div class="app-container agent-management">
    <div class="page-heading">
      <div>
        <h2>坐席管理</h2>
        <p>选择可以认领、接收和转派客服会话的后台账号。</p>
      </div>
      <el-button icon="el-icon-refresh" @click="loadAgents">刷新</el-button>
    </div>

    <div class="filter-row">
      <el-input
        v-model.trim="keyword"
        clearable
        placeholder="搜索账号或姓名"
        prefix-icon="el-icon-search"
        @keyup.enter.native="loadAgents"
      />
      <el-select v-model="enabledFilter" clearable placeholder="全部坐席状态" @change="loadAgents">
        <el-option label="已启用" :value="true" />
        <el-option label="未启用" :value="false" />
      </el-select>
      <el-button type="primary" @click="loadAgents">查询</el-button>
    </div>

    <el-table v-loading="loading" :data="agents" border>
      <el-table-column prop="account" label="后台账号" min-width="180" />
      <el-table-column prop="name" label="姓名" min-width="160" />
      <el-table-column label="账号状态" width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'success' : 'info'">{{
            scope.row.status === 0 ? "正常" : "已停用"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="activeConversationCount"
        label="进行中会话"
        width="130"
        align="center"
      />
      <el-table-column label="客服坐席" width="140" align="center">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.enabled"
            :disabled="scope.row.status !== 0 || changingId === scope.row.id"
            active-color="#409eff"
            @change="value => changeEnabled(scope.row, value)"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getKefuAgentList, updateKefuAgentEnabled } from "@/api/kefu";

export default {
  name: "CustomerServiceAgents",
  data() {
    return { keyword: "", enabledFilter: "", agents: [], loading: false, changingId: null };
  },
  created() {
    this.loadAgents();
  },
  methods: {
    async loadAgents() {
      this.loading = true;
      try {
        const params = { keyword: this.keyword };
        if (this.enabledFilter !== "") params.enabled = this.enabledFilter;
        this.agents = await getKefuAgentList(params);
      } catch (error) {
        this.$message.error(error.message || "坐席列表加载失败");
      } finally {
        this.loading = false;
      }
    },
    async changeEnabled(row, enabled) {
      this.changingId = row.id;
      try {
        await updateKefuAgentEnabled(row.id, enabled);
        row.enabled = enabled;
        this.$message.success(enabled ? "已设为客服坐席" : "已取消客服坐席");
      } catch (error) {
        this.$message.error(error.message || "坐席状态修改失败");
      } finally {
        this.changingId = null;
      }
    }
  }
};
</script>

<style scoped>
.agent-management {
  padding: 24px;
}
.page-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-heading h2 {
  margin: 0 0 8px;
  font-size: 22px;
}
.page-heading p {
  margin: 0;
  color: #909399;
}
.filter-row {
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
}
.filter-row .el-input {
  width: 280px;
}
.filter-row .el-select {
  width: 180px;
}
</style>
